import { PHONE_NUMBER_PREFIX } from 'modules/hooks/validationHooks';
import { UpdateUserData, User } from 'modules/types/User';

export enum ProfilePageKeys {
  Information = 'information-overview',
  DataModification = 'data-modification',
  PasswordReset = 'password-reset',
  ContactPerson = 'contact-person',
}

export enum EntityTypeCodes {
  PhysicalEntity = 'FO',
  LegalEntity = 'PO',
}

export const getProfilePageUrl = (tab: string) => `/profile/${tab}`;

export const getDefaultUserUpdateData = (user?: User): UpdateUserData => ({
  shippingStreet: user?.shippingStreet || '',
  shippingHouseNumber: user?.shippingHouseNumber || '',
  shippingPostalCode: user?.shippingPostalCode || '',
  shippingCountry: user?.shippingCountry || '',
  phone: user?.phone || {
    areaCode: user?.phone?.areaCode || PHONE_NUMBER_PREFIX,
    number: user?.phone?.number || '',
  },
  email: user?.email || '',
  contactPersonName: user?.contactPersonName || '',
  contactPersonPhone: user?.contactPersonPhone || {
    areaCode: user?.contactPersonPhone?.areaCode || PHONE_NUMBER_PREFIX,
    number: user?.contactPersonPhone?.number || '',
  },
});
